export default __webpack_public_path__ + "static/media/logo.276af8cc.svg";